module.exports = __webpack_public_path__ + "static/media/uBelong.acafad82.svg";